export function splitModelIdentifier(input: string): { model: string; body: string } {
  const [model, body] = input.split('-');
  return { model: model || '', body: body || '' };
}

export function removeClassSuffixForOneSearch(value: string | undefined): string {
  return value?.split('_')[0] ?? '';
}
